import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleOpportunityTaskDetails = () => {
  const { taskId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const decodedId = taskId ? atob(taskId) : taskId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['opportunityTask']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['opportunityTask'] + id + '/', { headers });
      showToast('Opportunity Task deleted successfully', 'success');
      navigate('/opportunity/task/list');
    } catch (error) {
      console.error('Error deleting OpportunityTask:', error);
      showToast('Failed to delete Opportunity Task', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Opportunity Task"
        listPath="/opportunity/task/list"
        editPath={`/opportunity/task/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Opportunity Task"
        message="Are you sure you want to delete this Opportunity Task?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleOpportunityTaskDetails;
